import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { adminGetkycActionType } from "../../redux/actions/adminGetKycActionTypeAction";
import { adminGetkycProofList } from "../../redux/actions/adminGetKycProofListAction";
import { adminAddOrUpdateKycProof } from "../../redux/actions/adminAddOrUpdateKycProofAction";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import val from "../../getThemeDetails"
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function AdminCreateProofType() {
	const [searchActionType, setSearchActionType] = useState("");

	const [page, setPage] = useState(0);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [addOpen, setAddOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);

	const [getKycActionTypeStatus, setGetKycActionTypeStatus] = useState(false);
	const [getKycActionTypeArray, setGetKycActionTypeArray] = useState([]);

	const [getKycProofListStatus, setGetKycProofListStatus] = useState(false);
	const [getKycProofListArray, setGetKycProofListArray] = useState([]);

	const [addOrUpdateProofStatus, setAddOrUpdateProofStatus] = useState(false);
	const [addOrUpdateProofArray, setAddOrUpdateProofArray] = useState([]);

	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const view = "view";
	const edit = "edit";

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [user, setUser] = useState({
		proofId: "",
		proofName: "",
		actionType: "",
		description: ""
	});

	const { proofId, proofName, actionType, description } = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
	};

	const getKycActionTypeRes = useSelector(
		({ adminGetKycActionType }) => adminGetKycActionType
	);

	const getKycProofListRes = useSelector(
		({ adminGetKycProofList }) => adminGetKycProofList
	);

	const addOrUpdateKycProofRes = useSelector(
		({ adminAddOrUpdateKycProof }) => adminAddOrUpdateKycProof
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "searchActionType") {
			setSearchActionType(value == "Select Action Type" ? "" : value);
		}
	};

	const getGetKycActionTypeReq = () => {
		setGetKycActionTypeStatus(true);
		let req = {
			adminId: val.adminIDS
			// adminId: 2
		};
		dispatch(adminGetkycActionType(req, authToken));
	};

	useEffect(() => {
		console.log(description, "////////////////////////////////////");
	}, [description]);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getGetKycActionTypeReq();
			getKycProofListReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	const getKycActionTypeFunc = () => {
		if (getKycActionTypeStatus) {
			if (getKycActionTypeRes.data.status == "success") {
				setGetKycActionTypeArray(getKycActionTypeRes.data.currencyList);
			}
			if (getKycActionTypeRes.data.status == "failed") {
				setGetKycActionTypeArray(getKycActionTypeRes.data);
				if (
					getKycActionTypeRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycActionTypeRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getKycActionTypeFunc();
	}, [getKycActionTypeRes.data.status]);

	const getKycProofListReq = () => {
		setGetKycProofListStatus(true);
		setIsLoading(true);
		let req = {
			// adminId: 2,
			adminId: val.adminIDS,
			actionType: searchActionType
		};
		dispatch(adminGetkycProofList(req, authToken));
	};

	const getGetKycProofListFunc = () => {
		if (getKycProofListStatus) {
			if (getKycProofListRes.data.status == "success") {
				setGetKycProofListArray(
					[].concat(getKycProofListRes.data.commonKycDetailsList)
				);
				setIsLoading(false);
			}
			if (getKycProofListRes.data.status == "failed") {
				setGetKycProofListArray(getKycProofListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getKycProofListRes.data.description
				);
				setIsLoading(false);
				if (
					getKycProofListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycProofListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getKycProofListRes.data.status == "NOT FOUND") {
				setGetKycProofListArray(getKycProofListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getKycProofListRes.data.description
				);
				setIsLoading(false);
			}
		}
	};

	useEffect(() => {
		getGetKycProofListFunc();
	}, [getKycProofListRes.data.status]);

	const addOrUpdateProofReq = () => {
		setAddOrUpdateProofStatus(true);
		setEditOpen(false);
		setAddOpen(false);
		let req = {
			actionType: actionType,
			proofName: proofName,
			description: description,
			adminId: val.adminIDS,
			// adminId: 2,
			kycId: proofId
		};
		dispatch(adminAddOrUpdateKycProof(req, authToken));
	};

	const addOrUpdateProofFunc = () => {
		if (addOrUpdateProofStatus) {
			if (addOrUpdateKycProofRes.data.status == "success") {
				setAddOrUpdateProofArray(addOrUpdateKycProofRes.data);
				setNotificationOpen(true);
				getKycProofListReq();
			}
			if (addOrUpdateKycProofRes.data.status == "failed") {
				setAddOrUpdateProofArray(addOrUpdateKycProofRes.data);
				setNotificationOpen(true);
				if (
					addOrUpdateKycProofRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateKycProofRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			setUser({
				proofId: "",
				proofName: "",
				actionType: "",
				description: ""
			});
		}
	};

	useEffect(() => {
		addOrUpdateProofFunc();
	}, [addOrUpdateKycProofRes.data.status]);

	const setData = (row, fs) => {
		if (fs == "view") {
			setViewOpen(true);
		}
		if (fs == "edit") {
			setEditOpen(true);
		}
		setUser({
			proofId: row.kycId,
			proofName: row.proofName,
			actionType: row.actionType,
			description: row.description
		});
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
		setAddOpen(false);
		setUser({
			proofId: "",
			proofName: "",
			actionType: "",
			description: ""
		});
	};

	const addProofType = () => {
		setAddOpen(true);
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							textAlign: "center"
						}}
					>
						<Grid item md={4} sm={12} lg={9}></Grid>
						<Grid item md={12} sm={12} lg={3} style={{ textAlign: "center" }}>
							{/* <Button
								variant="contained"
								style={{ backgroundColor: "#00b9f5", color: "white" }}
								size="small"
								onClick={() => addProofType()}
							>
								Add New Proof Type
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => addProofType()}
							>
								Add New Configuration
							</CustomButton>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								variant="standard"
								type="text"
								label="Action Type"
								fullWidth={true}
								name="searchActionType"
								defaultValue={"Select Action Type" || searchActionType}
								onChange={handleChange}
							>
								<MenuItem
									value="Select Action Type"
									selected="Select Action Type"
								>
									Select Action Type
								</MenuItem>
								{getKycActionTypeRes.data.currencyList &&
									getKycActionTypeArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>
											{x.split("-")[0]}
										</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getKycProofListReq}
							>
								Search
							</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={getKycProofListReq}
								>
									Search <SearchIcon />
								</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getKycProofListArray.length == undefined ||
				  getKycProofListArray.status == "NOT FOUND" ||
				  !getKycProofListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
                  className="themeText"
								
								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
                  className="themeText"
								
								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Proof Type ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Proof Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Description
											</TableCell>
											<TableCell
												colSpan={2}
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getKycProofListArray &&
											[]
												.concat(getKycProofListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">{row.kycId}</TableCell>
														<TableCell align="center">
															{row.proofName}
														</TableCell>
														<TableCell align="center">
															{row.actionType}
														</TableCell>
														<TableCell align="center">
															{row.description}
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, view)}
															>
																<VisibilityIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, edit)}
															>
																<EditIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getKycProofListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle>Edit Proof Type</DialogTitle>
						<DialogContent>
							<TextField
								required
								disabled
								variant="standard"
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Action Type"
								fullWidth={true}
								name="actionType"
								value={actionType || ""}
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Proof Name"
								variant="standard"

								fullWidth={true}
								name="proofName"
								value={proofName || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Description"
								fullWidth={true}
								name="description"
								defaultValue={description || ""}
								onChange={(e) => onInputChange(e, "both")}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<CustomButton
								style={{
									// backgroundColor: "#fff",
									// color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									// backgroundColor: "#00b9f5",
									// color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateProofReq}
							>
								Save
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle>View Proof Type</DialogTitle>
						<DialogContent>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								variant="standard"
								color="primary"
								type="text"
								label="Proof ID"
								fullWidth={true}
								name="proofId"
								value={proofId || ""}
							></TextField>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Action Type"
								fullWidth={true}
								name="actionType"
								value={actionType || ""}
							></TextField>

							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								variant="standard"

								color="primary"
								type="text"
								label="Proof Name"
								fullWidth={true}
								name="proofName"
								value={proofName || ""}
							></TextField>

							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Description"
								fullWidth={true}
								name="description"
								value={description || ""}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<CustomButton
								style={{
									// backgroundColor: "#00b9f5",
									// color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Close
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>
							Add Proof Type
						</DialogTitle>
						<DialogContent>
							<TextField
								required
								// select
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Action Type"
								fullWidth={true}
								variant="standard"
								name="actionType"
								value={actionType || ""}
								// defaultValue={"Select Action Type" || }
								onChange={(e) => onInputChange(e, "alphabet")}
							>
								{/* <MenuItem
									value="Select Action Type"
									selected="Select Action Type"
								>
									Select Action Type
								</MenuItem>
								{getKycActionTypeRes.data.currencyList &&
									getKycActionTypeArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>
											{x.split("-")[0]}
										</MenuItem>
									))} */}
							</TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Proof Name"
								fullWidth={true}
								name="proofName"
								variant="standard"

								value={proofName || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Description"
								variant="standard"

								fullWidth={true}
								name="description"
								defaultValue={description || ""}
								onChange={(e) => onInputChange(e, "both")}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<CustomButton
								style={{
									// backgroundColor: "#fff",
									// color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									// backgroundColor: "#00b9f5",
									// color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateProofReq}
							>
								Save
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{addOrUpdateProofArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateProofArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateProofArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c", width: "255px" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateProofArray.description.split("|").map((x) => (
									<p style={{ margin: "3px" }}>{x}</p>
								))}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									marginBottom: "10px",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default AdminCreateProofType;
